import React, { useRef } from 'react';

import EventCard from './EventCard';
import { Event } from './types';
import { IconXClose } from '@pentabd/icons';
import useOnClickOutside from '../../hooks/useOnClickOutside';

function EventPopUp({
  event,
  setActiveId,
  eventCard,
}: {
  event: Event;
  setActiveId: (data: string) => void;
  eventCard?: (data: Event) => React.JSX.Element;
}) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = () => {
    setActiveId('');
  };

  useOnClickOutside(wrapperRef, handleClickOutside);

  const popUpCard = () => (
    <div
      className="position-absolute event-card bg-white shadow-3xl z-9"
      ref={wrapperRef}
    >
      <div
        className="position-absolute right-0 p-3 pointer"
        onClick={() => setActiveId('')}
      >
        <IconXClose size="24" stroke="subtitle2" />
      </div>
      <div className="px-10 py-12">
        {eventCard ? eventCard(event) : <EventCard event={event} />}
      </div>
    </div>
  );
  return popUpCard();
}

export default EventPopUp;
